<template>
  <div>
     goodsInfo
  </div>
</template>

<script>
import {getGoodsInfo} from "@/api";

export default {
    data(){
        return {
            pid:null
        }
    },
    created(){
        this.pid = this.$route.query.pid;
        getGoodsInfo(this.pid).then(d=>{
            console.log(d)
        })
    },
    components:{
    }
}
</script>

<style lang="scss" scoped>

</style>